import { schemaScope } from "../scope.js";
export const jsObjects = schemaScope({
    Array,
    Function,
    Date,
    Error,
    Map,
    RegExp,
    Set,
    WeakMap,
    WeakSet,
    Promise
}, { prereducedAliases: true, registerKeywords: true }).export();
